export const ENVIRONMENTS = {
    PROD: "prod",
    DEV: "dev",
    E2E: "e2e"
}



// WEBPACK FOOTER //
// ./src/environments/environments.ts